import { useState } from 'react';
import useAuthStore from '../../store/authStore';
import api from '../../services/api';
import { Gift, X, Loader2, CheckCircle, AlertTriangle } from 'lucide-react';

export default function PendingGiftPopup() {
    const pendingGifts = useAuthStore(s => s.pendingGifts);
    const clearPendingGift = useAuthStore(s => s.clearPendingGift);
    const fetchProfile = useAuthStore(s => s.fetchProfile);

    const [activating, setActivating] = useState(false);
    const [activated, setActivated] = useState(null);
    const [error, setError] = useState(null);
    const [dismissed, setDismissed] = useState(new Set());

    // Show activated state first (takes priority)
    if (activated) {
        return (
            <div className="pending-gift-popup">
                <div className="pending-gift-popup__card pending-gift-popup__card--success">
                    <CheckCircle size={24} style={{ color: '#10b981' }} />
                    <div>
                        <strong>Cadeau activé !</strong>
                        <p>{activated.scope_label} — jusqu'au {new Date(activated.fin + 'T00:00:00').toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                    </div>
                    <button className="pending-gift-popup__close" onClick={() => setActivated(null)}>
                        <X size={16} />
                    </button>
                </div>
            </div>
        );
    }

    if (!pendingGifts || pendingGifts.length === 0) return null;

    // Show only the first non-dismissed gift
    const gift = pendingGifts.find(g => !dismissed.has(g.id));
    if (!gift) return null;

    const dureeLabels = { '1m': '1 mois', '2m': '2 mois', '6m': '6 mois', '12m': '12 mois' };

    const handleActivate = async () => {
        setActivating(true);
        setError(null);
        try {
            const { data } = await api.post('/gift/redeem.php', { code: gift.code });
            if (data.success) {
                setActivated(data.data);
                clearPendingGift(gift.id);
                // Backend a auto-ajouté le scope dans selectedScopes — force refresh
                // pour éviter que le merge "local gagne" écrase la valeur côté front.
                localStorage.removeItem('monquiz_dashboard_prefs');
                await fetchProfile();
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Erreur lors de l\'activation');
        }
        setActivating(false);
    };

    const handleDismiss = () => {
        setError(null);
        setDismissed(prev => new Set(prev).add(gift.id));
    };

    return (
        <div className="pending-gift-popup">
            <div className="pending-gift-popup__card">
                <Gift size={24} style={{ color: '#7c3aed', flexShrink: 0 }} />
                <div style={{ flex: 1 }}>
                    <strong>Vous avez un cadeau !</strong>
                    <p>
                        Abonnement <strong>{gift.scope_label}</strong> ({dureeLabels[gift.duree] || gift.duree})
                    </p>
                    {error && (
                        <p style={{ color: '#ef4444', fontSize: '0.82em', marginTop: 4, display: 'flex', alignItems: 'center', gap: 4 }}>
                            <AlertTriangle size={12} /> {error}
                        </p>
                    )}
                </div>
                <button
                    className="btn btn-primary btn-sm"
                    onClick={handleActivate}
                    disabled={activating}
                    style={{ whiteSpace: 'nowrap' }}
                >
                    {activating ? <Loader2 size={14} className="spin" /> : 'Activer'}
                </button>
                <button className="pending-gift-popup__close" onClick={handleDismiss}>
                    <X size={16} />
                </button>
            </div>
        </div>
    );
}
